import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";

import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import "./styles.scss";

import CorrectResult from "./img/correct-results.svg";
import BlankResult from "./img/results-blank.svg";
import EmptyResult from "./img/results-empty.svg";

class GelResults512 extends Component {
  convertOffset = (x) => {
    x = Math.round(x);

    if (x > 50) {
      return Math.round(Math.pow(2.71828, -((10 * x - 7504) / 1359)));
    } else {
      return 0;
    }
  };

  renderPredictedResults = () => {
    const { intl } = this.props;
    return (
      <div className="predictedResultsContainer512">
        <p style={{ color: "white" }}>
          <FormattedMessage
            id="Predicted Results"
            defaultMessage="Predicted Results"
            description=""
          />
        </p>
        <div className="lanes predictions">
          <div
            id="lane-1"
            className="lane lane-1"
            aria-label={intl.formatMessage(
              {
                id: "Wild type lane. {lane1a} {lane1b}.",
                defaultMessage: "Wild type lane. {lane1a} {lane1b}.",
                description: "",
              },
              {
                lane1a:
                  this.convertOffset(this.props.bands.lane1a) > 50
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane1a),
                        }
                      )
                    : "",
                lane1b:
                  this.convertOffset(this.props.bands.lane1b) > 50 &&
                  this.props.toggles.lane1
                    ? intl.formatMessage(
                        {
                          id: "CCR5 band at {offset} Bp.",
                          defaultMessage: "CCR5 band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane1b),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display: this.props.bands.lane1a > 50 ? null : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane1a * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
            <div
              className={"particle"}
              style={{
                display:
                  this.props.bands.lane1b > 50 && this.props.toggles.lane1
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane1b * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
          </div>
          <div
            id="lane-2"
            className="lane lane-2"
            aria-label={intl.formatMessage(
              {
                id: "Pancreas lane. {lane2a} {lane2b}.",
                defaultMessage: "Pancreas lane. {lane2a} {lane2b}.",
                description: "",
              },
              {
                lane2a:
                  this.convertOffset(this.props.bands.lane2a) > 50
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane2a),
                        }
                      )
                    : "",
                lane2b:
                  this.convertOffset(this.props.bands.lane2b) > 50 &&
                  this.props.toggles.lane2
                    ? intl.formatMessage(
                        {
                          id: "CCR5 band at {offset} Bp.",
                          defaultMessage: "CCR5 band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane2b),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display: this.props.bands.lane2a > 50 ? null : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane2a * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
            <div
              className={"particle"}
              style={{
                display:
                  this.props.bands.lane2b > 50 && this.props.toggles.lane2
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane2b * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
          </div>
          <div
            id="lane-3"
            className="lane lane-3"
            aria-label={intl.formatMessage(
              {
                id: "Edit 4 lane. {lane3a} {lane3b}.",
                defaultMessage: "Edit 4 lane. {lane3a} {lane3b}.",
                description: "",
              },
              {
                lane3a:
                  this.convertOffset(this.props.bands.lane3a) > 50
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane3a),
                        }
                      )
                    : "",
                lane3b:
                  this.convertOffset(this.props.bands.lane3b) > 50 &&
                  this.props.toggles.lane3
                    ? intl.formatMessage(
                        {
                          id: "CCR5 band at {offset} Bp.",
                          defaultMessage: "CCR5 band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane3b),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display: this.props.bands.lane3a > 50 ? null : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane3a * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
            <div
              className={"particle"}
              style={{
                display:
                  this.props.bands.lane3b > 50 && this.props.toggles.lane3
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane3b * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
          </div>
          <div
            id="lane-4"
            className="lane lane-4"
            aria-label={intl.formatMessage(
              {
                id: "Edit 7 lane. {lane4a} {lane4b}.",
                defaultMessage: "Edit 7 lane. {lane4a} {lane4b}.",
                description: "",
              },
              {
                lane4a:
                  this.convertOffset(this.props.bands.lane4a) > 50
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane4a),
                        }
                      )
                    : "",
                lane4b:
                  this.convertOffset(this.props.bands.lane4b) > 50 &&
                  this.props.toggles.lane4
                    ? intl.formatMessage(
                        {
                          id: "CCR5 band at {offset} Bp.",
                          defaultMessage: "CCR5 band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane4b),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display: this.props.bands.lane4a > 50 ? null : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane4a * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
            <div
              className={"particle"}
              style={{
                display:
                  this.props.bands.lane4b > 50 && this.props.toggles.lane4
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.bands.lane4b * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                position: "absolute",
              }}
            ></div>
          </div>
        </div>
        <img
          className="result-bg"
          style={{ pointerEvents: "none" }}
          alt={intl.formatMessage({
            id: "Predicted result, gel image.",
            defaultMessage: "Predicted result, gel image.",
            description: "",
          })}
          src={BlankResult}
        />
      </div>
    );
  };

  renderIdealResults = () => {
    const { intl } = this.props;
    return (
      <div className="idealResultsContainer512">
        <p style={{ color: "white" }}>
          <FormattedMessage
            id="Ideal Results"
            defaultMessage="Ideal Results"
            description=""
          />
        </p>
        <div className="lanes results">
          <div
            id="lane-1"
            className="lane lane-1"
            aria-label={intl.formatMessage({
              id: "Wild type lane. Alpha tubulin band at 55 Bp. CCR5 band at 40 Bp.",
              defaultMessage:
                "Wild type lane. Alpha tubulin band at 55 Bp. CCR5 band at 40 Bp.",
              description: "",
            })}
          ></div>
          <div
            id="lane-2"
            className="lane lane-2"
            aria-label={intl.formatMessage({
              id: "Pancreas lane. Alpha tubulin band at 55 Bp.",
              defaultMessage: "Pancreas lane. Alpha tubulin band at 55 Bp.",
              description: "",
            })}
          ></div>
          <div
            id="lane-3"
            className="lane lane-3"
            aria-label={intl.formatMessage({
              id: "Edit 4 lane. Alpha tubulin band at 55 Bp.",
              defaultMessage: "Edit 4 lane. Alpha tubulin band at 55 Bp.",
              description: "",
            })}
          ></div>
          <div
            id="lane-4"
            className="lane lane-4"
            aria-label={intl.formatMessage({
              id: "Edit 7 lane. Alpha tubulin band at 55 Bp.",
              defaultMessage: "Edit 7 lane. Alpha tubulin band at 55 Bp.",
              description: "",
            })}
          ></div>
        </div>
        <img
          className="result-bg"
          style={{ pointerEvents: "none" }}
          alt={intl.formatMessage({
            id: "Ideal result, gel image.",
            defaultMessage: "Ideal result, gel image.",
            description: "",
          })}
          src={CorrectResult}
        />
      </div>
    );
  };

  renderActualResults = () => {
    const { intl } = this.props;
    return (
      <div className="actualResultsContainer512">
        <p style={{ color: "white" }}>
          <FormattedMessage
            id="Actual Results"
            defaultMessage="Actual Results"
            description=""
          />
        </p>
        <div className="lanes results">
          <div
            id="lane-1"
            className="lane lane-1"
            aria-label={intl.formatMessage(
              {
                id: "Wild type lane. {lane1a} {lane1b}.",
                defaultMessage: "Wild type lane. {lane1a} {lane1b}.",
                description: "",
              },
              {
                lane1a:
                  this.props.results.lane1["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane1a),
                        }
                      )
                    : "",
                lane1b:
                  this.props.results.lane1["CCR5"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? intl.formatMessage(
                        {
                          id: "CCR5 band at {offset} Bp.",
                          defaultMessage: "CCR5 band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane1b),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane1["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane1["Alpha-tubulin"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            ></div>
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane1["CCR5"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane1["CCR5"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            ></div>
          </div>
          <div
            id="lane-2"
            className="lane lane-2"
            aria-label={intl.formatMessage(
              {
                id: "Pancreas lane. {lane2a}",
                defaultMessage: "Pancreas lane. {lane2a}",
                description: "",
              },
              {
                lane2a:
                  this.props.results.lane2["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane2a),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane2["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane2["Alpha-tubulin"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            ></div>
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane2["CCR5"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane2["CCR5"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            ></div>
          </div>
          <div
            id="lane-3"
            className="lane lane-3"
            aria-label={intl.formatMessage(
              {
                id: "Edit 4 lane. {lane3a}",
                defaultMessage: "Edit 4 lane. {lane3a}",
                description: "",
              },
              {
                lane3a:
                  this.props.results.lane3["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane2a),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane3["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane3["Alpha-tubulin"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            ></div>
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane3["CCR5"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane3["CCR5"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            ></div>
          </div>

          <div
            id="lane-4"
            className="lane lane-4"
            aria-label={intl.formatMessage(
              {
                id: "Edit 7 lane. {lane4a}",
                defaultMessage: "Edit 7 lane. {lane4a}",
                description: "",
              },
              {
                lane4a:
                  this.props.results.lane4["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? intl.formatMessage(
                        {
                          id: "Alpha tubulin band at {offset} Bp.",
                          defaultMessage: "Alpha tubulin band at {offset} Bp.",
                          description: "",
                        },
                        {
                          offset: this.convertOffset(this.props.bands.lane2a),
                        }
                      )
                    : "",
              }
            )}
          >
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane4["Alpha-tubulin"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane4["Alpha-tubulin"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            >
              <p className="particle-label">
                Alpha-tubulin
                <br />
                55kDa
              </p>
            </div>
            <div
              className="particle"
              style={{
                display:
                  this.props.results.lane4["CCR5"] > 0 &&
                  this.props.interactionProps.nitro.imaged &&
                  this.props.interactionProps.nitro.incubated[
                    "Primary antibody"
                  ] &&
                  this.props.interactionProps.nitro.incubated[
                    "Secondary antibody"
                  ] &&
                  this.props.interactionProps.nitro.run
                    ? null
                    : "none",
                transform:
                  "translate3d(0px, " +
                  this.props.results.lane4["CCR5"] * 0.834 +
                  "px, 0px) rotateZ(0deg)",
                zIndex: 10,
                opacity: this.props.interactionProps.nitro.opacity,
                position: "absolute",
              }}
            >
              <p className="particle-label">
                CCR5
                <br />
                40kDa
              </p>
            </div>
          </div>
        </div>
        <img
          className="result-bg"
          style={{ pointerEvents: "none" }}
          alt={intl.formatMessage({
            id: "Actual result, gel image.",
            defaultMessage: "Actual result, gel image.",
            description: "",
          })}
          src={
            this.props.interactionProps.nitro.imaged &&
            this.props.interactionProps.nitro.run
              ? BlankResult
              : EmptyResult
          }
        />
      </div>
    );
  };

  render() {
    return (
      <div className="Gel-results">
        {this.props.component === "Predicted" && this.renderPredictedResults()}
        {this.props.component === "Actual" && this.renderActualResults()}
        {this.props.component === "Ideal" && this.renderIdealResults()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bands: state.predictions.bands,
    toggles: state.predictions.toggles,
    // Dummy Data for actual results
    results: {
      lane1: {
        "Alpha-tubulin": 197,
        CCR5: 260,
      },
      lane2: {
        "Alpha-tubulin": 197,
        CCR5: 0,
      },
      lane3: {
        "Alpha-tubulin": 197,
        CCR5: 0,
      },
      lane4: {
        "Alpha-tubulin": 197,
        CCR5: 260,
      },
    },
    interactionProps: {
      nitro: {
        id: 1,
        type: "Nitrocellulose",
        description:
          "Nitrocellulose membranes washed in TBST have a high affinity for proteins. Used in the Western blot sandwich.",
        inScene: true,
        onShelf: true,
        held: false,
        shakenCount: 0,
        imaged: false,
        run: false,
        opacity: 0,
        controlsVisible: false,
        incubated: {
          "Primary antibody": false,
          "Secondary antibody": false,
        },
        label: "Nitrocellulose Membrane",
      },
    },
  };
};

const GelResults512WithIntl = injectIntl(GelResults512);

export default connect(
  mapStateToProps,
  {}
)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <GelResults512WithIntl {...props} />
  </TranslationsProvider>
));
